/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTYPEOFMONEY = {
    Compulsory: '1',
    Voluntary: '2',
    Both: '3'
} as const;
export type IAPTYPEOFMONEY = typeof IAPTYPEOFMONEY[keyof typeof IAPTYPEOFMONEY];


export function IAPTYPEOFMONEYFromJSON(json: any): IAPTYPEOFMONEY {
    return IAPTYPEOFMONEYFromJSONTyped(json, false);
}

export function IAPTYPEOFMONEYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTYPEOFMONEY {
    return json as IAPTYPEOFMONEY;
}

export function IAPTYPEOFMONEYToJSON(value?: IAPTYPEOFMONEY | null): any {
    return value as any;
}

